import { render, staticRenderFns } from "./MailTemplateLayoutCreate.vue?vue&type=template&id=31b8b522&scoped=true"
import script from "./MailTemplateLayoutCreate.vue?vue&type=script&lang=js"
export * from "./MailTemplateLayoutCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b8b522",
  null
  
)

export default component.exports